import { Bar, BarChart, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { Card } from "../../../../components/ui/card";
import type { DailyTrendData } from "../../../../shared/schema";

interface DailyTrendChartProps {
  data: DailyTrendData[];
  title?: string;
}

export function DailyTrendChart({ data, title = "Xu hướng lịch hẹn theo ngày" }: DailyTrendChartProps) {
  return (
    <Card className="p-6 border border-card-border">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-base font-semibold text-foreground">{title}</h3>
        <span className="text-xs text-muted-foreground">7 ngày gần nhất</span>
      </div>
      <div className="h-[300px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
            <XAxis 
              dataKey="dayShort" 
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: "hsl(var(--muted-foreground))" }}
            />
            <YAxis 
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: "hsl(var(--muted-foreground))" }}
            />
            <Tooltip
              content={({ active, payload }) => {
                if (!active || !payload || !payload.length) return null;
                const data = payload[0].payload as DailyTrendData;
                return (
                  <div className="bg-popover border border-popover-border rounded-lg px-3 py-2 shadow-lg">
                    <p className="text-sm font-medium text-foreground">{data.day}</p>
                    <p className="text-sm text-muted-foreground">
                      {data.appointments} lịch hẹn
                    </p>
                  </div>
                );
              }}
            />
            <Bar dataKey="appointments" radius={[4, 4, 0, 0]} maxBarSize={50}>
              {data.map((entry, index) => (
                <Cell 
                  key={`cell-${index}`}
                  fill={entry.isToday ? "hsl(var(--primary))" : "hsl(var(--muted))"}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}
